import http from '@/utils/http';

export interface IUserPermission {
  admin_mode: boolean;
  grc: boolean;
  iic: boolean;
}

const normalizePermissionResponse = (data: any): IUserPermission => {
  return {
    admin_mode: !!data?.data?.admin_mode,
    grc: !!data?.data?.grc,
    iic: !!data?.data?.iic,
  };
};

export const fetchUserPermissions = async (): Promise<IUserPermission> => {
  try {
    const res = await http({
      url: '/api/v1/intelligence_pc/user/permission',
      method: 'post',
      data: {},
      rawData: true,
    });
    return normalizePermissionResponse(res);
  } catch (error) {
    console.error('Failed to fetch user permissions', error);
    // Default to basic permissions on error
    return { admin_mode: false, grc: false, iic: false };
  }
};

export const filterCategoriesByPermission = (categories: any[], permissions: IUserPermission): any[] => {
  const baseValues = ['intelligence_insights', 'intelligence_ai'];
  const allowedValues = new Set([
    ...baseValues,
    ...(permissions.grc ? ['gameResearch'] : []),
    ...(permissions.iic ? ['intelligence_iic'] : []),
  ]);

  if (permissions.grc && permissions.iic) {
    return categories;
  }

  return categories.filter((category) => allowedValues.has(category?.value));
};

export const validateCategoryPermission = (l1Value: string, permissions: IUserPermission): boolean => {
  if (permissions.grc) {
    return true;
  }

  if (l1Value === 'gameResearch') {
    return false;
  }

  if (permissions.iic) {
    return true;
  }

  if (l1Value === 'intelligence_iic') {
    return false;
  }

  return true;
};
